import { reactive } from "vue";

const ACCENT_OPTIONS = [
  { id: "sky", name: "天空蓝", color: "#1a9be8" },
  { id: "coral", name: "珊瑚粉", color: "#ff6b84" },
  { id: "teal", name: "青绿色", color: "#14b8a6" },
  { id: "amber", name: "琥珀黄", color: "#f59e0b" },
];

const themeState = reactive({
  isDark: false,
  accent: "sky",
  panelOpen: false,
});

const applyThemeAttrs = () => {
  document.documentElement.setAttribute(
    "data-theme",
    themeState.isDark ? "dark" : "light"
  );
  document.documentElement.setAttribute("data-accent", themeState.accent);
};

export const useTheme = () => {
  const toggleTheme = () => {
    themeState.isDark = !themeState.isDark;
    localStorage.setItem("theme-mode", themeState.isDark ? "dark" : "light");
    applyThemeAttrs();
  };

  const setAccent = (accentId) => {
    const valid = ACCENT_OPTIONS.some((item) => item.id === accentId);
    themeState.accent = valid ? accentId : "sky";
    localStorage.setItem("theme-accent", themeState.accent);
    applyThemeAttrs();
  };

  const togglePanel = () => {
    themeState.panelOpen = !themeState.panelOpen;
  };

  const closePanel = () => {
    themeState.panelOpen = false;
  };

  const initializeTheme = () => {
    const savedMode = localStorage.getItem("theme-mode");
    const savedAccent = localStorage.getItem("theme-accent");
    themeState.isDark = savedMode === "dark";
    themeState.accent = ACCENT_OPTIONS.some((item) => item.id === savedAccent)
      ? savedAccent
      : "sky";
    applyThemeAttrs();
  };

  return {
    themeState,
    accentOptions: ACCENT_OPTIONS,
    toggleTheme,
    setAccent,
    togglePanel,
    closePanel,
    initializeTheme,
  };
};
